// src/constants/index.js   ← or wherever you keep your constants

// ──────────────────────────────────────────────────────────────
// PERSONAL INFO
// ──────────────────────────────────────────────────────────────
export const PERSONAL_INFO = {
  name: "Adwoa B. Acheampong (Miracle)",
  role: "Systems Builder & Growth Strategist",
  email: "adwoaacheampong728@gmail.com",
  phone: "(233) 276-291-485",
  location: "Accra, Ghana",
  linkedIn: "https://linkedin.com/in/adwoa-acheampong",
  github: "https://github.com/adwoa-acheampong"
};

// ──────────────────────────────────────────────────────────────
// EXPERIENCE (updated to match new ExperiencePage)
// ──────────────────────────────────────────────────────────────
export const EXPERIENCE = [
  {
    role: "Statutory Operations Director",
    company: "JonMon-Sacs Ghana Ltd",
    date: "Jul 2025 - Present",
    location: "Accra, Ghana",
    achievements: [
      "Superintending business licensing and regulatory compliance",
      "Leading a team of 5 officers",
      "Ensuring adherence to Ghanaian business laws"
    ]
  },
  {
    role: "Operations Manager",
    company: "Baa & Bean Café's",
    date: "Feb 2024 - Jul 2024",
    location: "Accra, Ghana",
    achievements: [
      "Drove daily revenue from GHS 12k to GHS 30k+ (120% increase)",
      "Implemented data-driven menu optimization",
      "Restructured supply chain operations",
      "Focused on sustainable growth vs. one-off wins"
    ]
  },
  {
    role: "Operations Consultant",
    company: "Automobiles Ghana Limited",
    date: "2024 & 2026",
    location: "Accra, Ghana",
    achievements: [
      "Amplified customer engagement by 83.3%",
      "Accelerated daily sales from GHS 1,200 to GHS 2,700",
      "Built repeat-customer models enabling 2-branch expansion",
      "Re-engaged to replicate success in next growth phase"
    ]
  },
  {
    role: "Administration Manager",
    company: "Zein Real Estate",
    date: "Mar 2023 - Jan 2024",
    location: "Accra, Ghana",
    achievements: [
      "Improved office productivity by 30%",
      "Built automation with AppScript + AI",
      "Created digital filing systems",
      "Freed team to focus on client relationships"
    ]
  },
  {
    role: "Marketing Executive",
    company: "Trident Real Estate Group",
    date: "2022 - 2023",
    location: "Accra, Ghana",
    achievements: [
      "Executed marketing campaigns for luxury projects",
      "Monitored lead turnover rates",
      "Utilized Meta Business Suite for remote sales",
      "Managed social media assets"
    ]
  }
];

// ──────────────────────────────────────────────────────────────
// DASHBOARD DATA (moved from App.js)
// ──────────────────────────────────────────────────────────────
export const BAA_AND_BEAN_DATA = [
  { month: 'Feb', revenue: 12000, target: 15000 },
  { month: 'Mar', revenue: 18000, target: 18000 },
  { month: 'Apr', revenue: 24000, target: 21000 },
  { month: 'May', revenue: 28000, target: 24000 },
  { month: 'Jun', revenue: 30000, target: 27000 },
  { month: 'Jul', revenue: 31500, target: 30000 }
];

export const AUTOMOBILES_DATA = [
  { week: 'Week 1', sales: 1200, engagement: 45 },
  { week: 'Week 2', sales: 1350, engagement: 52 },
  { week: 'Week 3', sales: 1580, engagement: 61 },
  { week: 'Week 4', sales: 1820, engagement: 68 },
  { week: 'Week 5', sales: 2100, engagement: 75 },
  { week: 'Week 6', sales: 2350, engagement: 78 },
  { week: 'Week 7', sales: 2550, engagement: 82 },
  { week: 'Week 8', sales: 2700, engagement: 83.3 }
];

// ──────────────────────────────────────────────────────────────
// SKILLS (grouped for SkillsPage)
// ──────────────────────────────────────────────────────────────
export const SKILLS = {
  dataAnalytics: [
    'SQL', 'Tableau', 'Power BI', 'Google Sheets',
    'AppScript', 'Data Visualization', 'Statistical Analysis', 'Excel Advanced'
  ],
  operations: [
    'Process Optimization', 'SOP Development', 'Supply Chain',
    'Team Leadership', 'Project Management', 'Compliance', 'Automation'
  ],
  technical: [
    'Python', 'JavaScript', 'React', 'AI Integration',
    'Google Workspace', 'Meta Business Suite', 'CRM Systems'
  ],
  certifications: [
    'Data Analysis - ALX',
    'Intermediate SQL - DataCamp',
    'Data Analysis Essentials - Cisco',
    'Business Management - Oxford Home Study Centre'
  ]
};

// ──────────────────────────────────────────────────────────────
// PROJECTS (for ProjectsPage)
// ──────────────────────────────────────────────────────────────
export const PROJECTS = [
  {
    id: 'agl-ops',
    title: 'AGL Ops — Enterprise Operations Platform',
    category: 'Operations & Engineering',
    description: 'A comprehensive operations management platform built for Automobiles Ghana Limited. Combines a real-time Command Center dashboard with a mobile-first Staff Hub PWA to manage sales, workshop operations, inventory, and financial tracking across multiple departments.',
    features: [
      'Live financial dashboard with real-time KPIs, revenue trends, and payment mix analytics',
      'Role-based Staff Hub PWA with clock-in/out, task logging, and work assignments',
      'Workshop & maintenance tracking with mechanic assignment and supervisor oversight',
      'Multi-channel sales tracking (Walk-In, WhatsApp, Phone, Social, Wholesale)',
      'Inventory & POS system with low-stock alerts and warehouse tracking',
      'Comprehensive reporting suite with CSV/PDF export and Google Sheets sync'
    ],
    tech: ['JavaScript', 'HTML5', 'CSS3', 'Chart.js', 'Playwright', 'PWA', 'Google Sheets API'],
    metrics: [
      { label: 'Dashboard Pages', value: '14+' },
      { label: 'Automated Tests', value: '30+' },
      { label: 'Revenue Impact', value: '125%' }
    ],
    status: 'Live',
    link: null
  },
  {
    id: 'avenue-lincoln',
    title: 'Avenue Lincoln — Luxury Property Booking Platform',
    category: 'Full-Stack Development',
    description: 'A luxury villa booking platform for Adebi Villa in Accra\'s prestigious Avenue Lincoln Estate, Ridge. Full-stack application featuring an elegant responsive frontend, integrated booking management with date validation, and an admin dashboard — located two streets from the British High Commission.',
    features: [
      'Online booking system with date validation, guest count, and stay duration calculation',
      'Admin booking dashboard via REST API with complete guest information',
      'Responsive design with hero animations, sparkle canvas effects, and smooth scrolling',
      'Interactive statistics bar showcasing property highlights at a glance',
      'Comprehensive amenities showcase with pricing structure (up to 25% long-stay discounts)',
      'Mobile-friendly navigation with 7 content sections'
    ],
    tech: ['Node.js', 'Express.js', 'HTML5', 'CSS3', 'JavaScript', 'Web3Forms'],
    metrics: [
      { label: 'Bedrooms', value: '3+' },
      { label: 'Sections', value: '7' },
      { label: 'Booking Flow', value: 'End-to-End' }
    ],
    status: 'Deployed',
    link: null
  },
  {
    id: 'sales-analysis',
    title: 'Restaurant Sales Insights — Data Analysis',
    category: 'Data Analytics',
    description: 'A comprehensive data analysis project examining full-year (2023) sales trends for a restaurant business. Demonstrates end-to-end analytical capabilities from data cleaning through statistical analysis to executive-ready visualizations and actionable business insights.',
    features: [
      'Time series analysis with 7-day moving average to identify true sales trends',
      'Peak performance analysis — identified highest sales day (GH₵792) and monthly patterns',
      'Day-of-week patterns proving consistent weekend outperformance',
      'Holiday impact study comparing holiday vs. non-holiday average sales',
      'Statistical profiling with mean, standard deviation, and distribution analysis',
      'Executive-ready PowerPoint presentation with charts and recommendations'
    ],
    tech: ['Python', 'Pandas', 'NumPy', 'Matplotlib', 'PowerPoint'],
    metrics: [
      { label: 'Data Points', value: '365' },
      { label: 'Visualizations', value: '8' },
      { label: 'Peak Revenue', value: 'GH₵792' }
    ],
    status: 'Complete',
    link: null
  }
];

// ──────────────────────────────────────────────────────────────
// PIPELINE PROJECTS (for PipelinePage)
// ──────────────────────────────────────────────────────────────
export const PIPELINE_PROJECTS = [
  {
    id: 'sme-hub',
    title: 'The Merchant Hub',
    tagline: 'Empowering Africa\'s Next Generation of Founders',
    phase: 'Development',
    phaseIndex: 2, // 0=Concept, 1=Planning, 2=Development, 3=Launch
    icon: 'TrendingUp',
    vision: 'A digital marketplace and founder ecosystem empowering SMEs and young entrepreneurs across Africa. We handle the digital heavy-lifting — ads, logistics, and all digital affairs — so founders can focus on what they do best: building.',
    keyOfferings: [
      { title: 'Digital Operations', desc: 'Full-service digital advertising, marketplace listing management, and e-commerce logistics handled by our team.' },
      { title: 'Founder Training', desc: 'Structured programs training founders to run businesses to corporate and global standards — from financial literacy to governance.' },
      { title: 'Executive Assistance', desc: 'Free EA services drawn from our operations expertise — calendar management, correspondence, and admin support for early-stage founders.' },
      { title: 'Community Commerce', desc: 'A marketplace where SMEs sell directly to consumers with integrated payment, delivery, and customer service infrastructure.' },
    ],
    communityModel: {
      title: 'African Money Pooling — Susu Reinvented',
      description: 'Rooted in the traditional Ghanaian "Susu" savings system, our community model builds collective wealth without debt.',
      pillars: [
        { label: '10% Tithe', detail: 'Forwarded to each founder\'s designated church or charity — honouring the spiritual foundation of African enterprise.' },
        { label: '20% Capital Pool', detail: 'Pooled monthly from all members and cycled to one founder\'s business for capital scaling. Every member benefits in rotation.' },
        { label: 'Zero Loans', detail: 'No interest, no debt traps. Growth funded by community trust and collective discipline.' },
      ],
    },
    targetMarket: 'Young founders (18–35), market women transitioning to digital, diaspora entrepreneurs investing back home.',
    differentiators: [
      'Not just a marketplace — a full founder support ecosystem',
      'Community-funded growth model eliminates startup debt',
      'Bridges informal African trade with formal global standards',
    ],
  },
  {
    id: 'real-estate-hub',
    title: 'Real Estate Management Hub',
    tagline: 'Redefining Property Management Across Africa',
    phase: 'Concept',
    phaseIndex: 0,
    icon: 'Building2',
    vision: 'A property management platform for owners who struggle to properly manage and market their properties. We don\'t just list — we host, train, manage, and deliver world-class hospitality.',
    keyOfferings: [
      { title: 'Property Hosting', desc: 'Properties listed on our platform with professional photography, pricing strategy, and booking management.' },
      { title: 'Staff Training', desc: 'We recruit, train, and deploy management and concierge staff — ensuring every property delivers 5-star experiences.' },
      { title: 'Travel Management', desc: 'Full travel concierge services for guests: airport transfers, local experiences, dining reservations, and itinerary planning.' },
      { title: 'Owner Dashboard', desc: 'Real-time occupancy, revenue, maintenance, and guest feedback analytics for property owners.' },
    ],
    communityModel: null,
    targetMarket: 'Property owners in Accra, Aburi, Cape Coast, and diaspora investors with Ghanaian real estate holdings.',
    differentiators: [
      'Free live video property tours for international clients — no more relying on static images',
      'Real-time virtual walkthroughs with full hospitality assurance',
      'Built on Avenue Lincoln as our proof of concept',
    ],
    proofOfConcept: {
      title: 'Avenue Lincoln — Adebi Villa',
      description: 'Our first property under management. A luxury 3-bedroom villa in Ridge, Accra — two streets from the British High Commission. Full booking platform live and operational.',
      link: null,
    },
  },
];

export const PIPELINE_PHASES = ['Concept', 'Planning', 'Development', 'Launch'];

// ──────────────────────────────────────────────────────────────
// NAVIGATION (for future use)
// ──────────────────────────────────────────────────────────────
export const NAVIGATION_LINKS = [
  { id: 'home', label: 'Home', icon: 'Coffee' },
  { id: 'story', label: 'My Story', icon: 'BookOpen' },
  { id: 'projects', label: 'Projects', icon: 'BarChart3' },
  { id: 'experience', label: 'Experience', icon: 'Briefcase' },
  { id: 'skills', label: 'Skills', icon: 'Award' },
  { id: 'pipeline', label: 'Pipeline', icon: 'TrendingUp' },
  { id: 'contact', label: 'Contact', icon: 'Mail' }
];

const content = {
  PERSONAL_INFO,
  EXPERIENCE,
  BAA_AND_BEAN_DATA,
  AUTOMOBILES_DATA,
  SKILLS,
  PROJECTS,
  PIPELINE_PROJECTS,
  PIPELINE_PHASES,
  NAVIGATION_LINKS
};

export default content;
